export const COLLAPSED_SEARCH_LIMIT = 25;
export const SEARCH_RESULT_LIMIT = 50;
